import { defineChain } from 'viem'

export const ducxTestnet = defineChain({
  id: 26482,
  name: 'DucatusX Testnet',
  testnet: true,
  nativeCurrency: {
    decimals: 18,
    name: 'DUCX',
    symbol: 'DUCX',
  },
  rpcUrls: {
    public: { http: ['https://ducx-testnet-node1.rocknblock.io'] },
    default: { http: ['https://ducx-testnet-node1.rocknblock.io'] },
  },
  blockExplorers: {
    default: {
      name: 'DUCX Explorer',
      url: 'https://ducx-explorer-testnet.rocknblock.io',
    },
  },
})

export const ducxMainnet = defineChain({
  id: 26483,
  name: 'DUCX',
  nativeCurrency: {
    decimals: 18,
    name: 'DUCX',
    symbol: 'DUCX',
  },
  rpcUrls: {
    public: { http: ['https://ducx-mainnet-node1.rocknblock.io'] },
    default: { http: ['https://ducx-mainnet-node1.rocknblock.io'] },
  },
  blockExplorers: {
    default: {
      name: 'DUCX Explorer',
      url: 'https://explorer.ducatusx.com/',
    },
  },
})
